import { Directive, ElementRef, EventEmitter, forwardRef, Injector, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  selector: 'mode-notebook-cell-ace',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NotebookCellAceDirective),
      multi: true,
    },
  ],
})
export class NotebookCellAceDirective extends UpgradeComponent implements ControlValueAccessor {
  @Input() lang: any;
  @Input() session: any;
  @Input() csrfToken: any;
  @Input() readOnly: any;
  @Input() secretKeys: any;
  @Input() controlEvents: any;
  @Input() ngModel: any;

  @Output() ngModelChange = new EventEmitter<any>();
  @Output() onBlur = new EventEmitter();
  @Output() onFocus = new EventEmitter();
  @Output() onTextChanged = new EventEmitter();
  private onChangeFn: (_: any) => void = () => {};
  private onTouchedFn: () => void = () => {};
  constructor(elementRef: ElementRef, injector: Injector) {
    super('modeNotebookAce', elementRef, injector);
  }

  // For ngModel -> directive
  writeValue(value: any): void {
    this.ngModel = typeof value === 'string' ? { $text: value } : value;
  }

  // For directive -> ngModel
  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
    this.ngModelChange.subscribe((val: any) => {
      const unwrapped = typeof val === 'string' ? val : val?.$text;
      this.onChangeFn(unwrapped);
    });
  }

  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.readOnly = isDisabled;
  }
}
